<template>
    <v-layout v-if="qrcode" column align-center justify-center align-content-center>
        <v-spacer class="my-3"></v-spacer>
        <qrcode :value="qrcode" :options="{ width: 300 }"></qrcode>
        <v-spacer class="my-3"></v-spacer>
        <h2>{{ $vuetify.t('$vuetify.qrcode_show_message') }}</h2>
    </v-layout>
</template>

<script>
    export default {
        name: "QRCode",
        data: () => ({
            qrcode: null
        }),
        mounted() {
            this.username = this.$store.state.authentication.user.username;
            this.qrcode = this.username.split('-')[1];
        },
    }
</script>

<style scoped>

</style>